import type { Icon } from "@ebay/experience-types-ebay";

export interface Input extends Marko.HTML.Div {
  locateMe?: Icon;
  disabled?: boolean;
  "on-cta-click": (forceCenter: boolean) => void;
}

export default class extends Marko.Component<Input> {
  onCtaClick() {
    this.emit("cta-click", true);
  }
}
